/* eslint-disable guard-for-in */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable new-cap */
/* eslint-disable camelcase */
import { Injectable, inject } from "@angular/core";
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import md5 from "md5";
import * as showdown from "showdown";
import * as sunriseSunset from "sunrise-sunset-js";
import { DatabaseService } from "../services/database/database.service";
import { targetPlatformEnum } from "./opsctrl-foc/dataStruct";
import { focMain } from "./opsctrl-foc/focMain";

@Injectable({
  providedIn: "root",
})
export class plugins {
  private database = inject(DatabaseService);

  public focMain: focMain;

  constructor() {
    const database = this.database;

    this.focMain = new focMain(
      targetPlatformEnum.na,
      database,
      { Directory, Encoding, Filesystem },
      undefined,
      md5,
      showdown,
      sunriseSunset
    );
  }
}
